import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    borderRadius: 24,
    overflow: "hidden",
    boxShadow:
      theme.palette.mode === "dark"
        ? "0 10px 30px rgba(88, 189, 253, 0.15)"
        : "0 10px 30px rgba(0, 0, 0, 0.06)",
    background: theme.palette.background.default,
    transition: "transform 0.35s ease, box-shadow 0.35s ease",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    "&:hover": {
      // transform: "translateY(-8px)",
      boxShadow:
        theme.palette.mode === "dark"
          ? "0 20px 50px rgba(88, 189, 253, 0.25)"
          : "0 20px 50px rgba(0, 0, 0, 0.12)",
    },
  },

  cardActionArea: {
    cursor: "default",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },

  focus: {
    backgroundColor: "transparent",
  },

  ripple: {
    display: "none",
  },

  mediaContainer: {
    position: "relative",
    width: "100%",
    height: 450,
    overflow: "hidden",
  },

  cardMedia: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "transform 0.5s ease",
    "$cardRoot:hover &": {
      transform: "scale(1.05)",
    },
  },

  countryBadge: {
    position: "absolute",
    top: 20,
    left: 20,
    backgroundColor: "#ffffff",
    color: "#0A1128",
    padding: "8px 20px",
    borderRadius: 100,
    fontSize: 12,
    fontWeight: 900,
    textTransform: "uppercase",
    letterSpacing: "1.2px",
    zIndex: 2,
    boxShadow:
      theme.palette.mode === "dark"
        ? "0 6px 18px rgba(0, 0, 0, 0.4)"
        : "0 4px 12px rgba(0, 0, 0, 0.08)",
    transition: "transform 0.3s ease",
    "$cardRoot:hover &": {
      transform: "scale(1.05)",
    },
  },

  cardContent: {
    padding: theme.spacing(3, 3, 2, 3),
    textAlign: "left",
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  categoryRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1.5),
    "&::before": {
      content: '""',
      width: 8,
      height: 8,
      backgroundColor: theme.palette.text.titleProjects,
      borderRadius: "50%",
      marginRight: 10,
      flexShrink: 0,
    },
  },

  categoryText: {
    color: theme.palette.text.titleProjects,
    fontSize: 12,
    fontWeight: 800,
    textTransform: "uppercase",
    letterSpacing: "1.3px",
  },

  projectTitle: {
    fontWeight: 900,
    fontSize: "2.5rem",
    color: theme.palette.text.nonary,
    textTransform: "uppercase",
    marginBottom: theme.spacing(2),
    letterSpacing: "-1px",
    lineHeight: 1.1,
    textAlign: "left",
    transition: "color 0.3s ease",
    "$cardRoot:hover &": {
      color: theme.palette.text.titleProjects,
    },
  },

  projectDescription: {
    color: theme.palette.text.projects,
    fontSize: 15,
    lineHeight: 1.65,
    textAlign: "left",
    marginBottom: theme.spacing(1),
  },

  cardFooter: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2, 3, 3, 3),
    marginTop: "auto",
  },

  statBox: {
    display: "flex",
    flexDirection: "column",
  },

  statLabel: {
    fontSize: 11,
    fontWeight: 700,
    color:
      theme.palette.mode === "dark"
        ? theme.palette.text.selectProjects
        : "#A0A0A0",
    textTransform: "uppercase",
    letterSpacing: "0.8px",
    marginBottom: 4,
  },
  statValue: {
    fontSize: 22,
    fontWeight: 800,
    color: theme.palette.text.titleProjects,
    letterSpacing: "-0.5px",
  },

  btnIcon: {
    fontSize: 20,
    transition: "transform 0.3s ease",
    "$projectBtn:hover &": {
      transform: "translateX(3px)",
    },
  },
}));

export default useStyles;
